import { Box, Button, Checkbox, FormControl, HStack, Heading, Skeleton, VStack } from '@chakra-ui/react';
import { HTTP } from '@utils/http';
import FloatingLabelInput from 'components/FloatingLabelInput';
import { useFetchMe } from 'hooks/useApiQueries';
import { t } from 'i18next';
import { FormProvider, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router';
import { MindbodyUser } from 'types/client';

type FormData = Pick<
  MindbodyUser,
  'FirstName' | 'LastName' | 'AddressLine1' | 'PostalCode' | 'City' | 'MobilePhone' | 'Email' | 'SendPromotionalEmails'
>;

export function ProfileEdit() {
  const { isLoading } = useFetchMe();

  return (
    <Skeleton isLoaded={!isLoading}>
      <ProfileEditForm />
    </Skeleton>
  );
}

function ProfileEditForm() {
  const navigate = useNavigate();
  const { data: user } = useFetchMe();
  function getDefaultValues(): Partial<FormData> {
    if (!user) return {};
    const { FirstName, LastName, AddressLine1, PostalCode, City, MobilePhone, Email, SendPromotionalEmails } = user;
    return {
      FirstName,
      LastName,
      AddressLine1,
      PostalCode,
      City,
      MobilePhone,
      Email,
      SendPromotionalEmails,
    };
  }

  const formMethods = useForm<FormData>({
    defaultValues: getDefaultValues(),
  });

  const {
    register,
    handleSubmit,
    formState: { isSubmitting },
  } = formMethods;

  const onSubmit = async (formData: Partial<MindbodyUser>) => {
    try {
      await HTTP.post<{ Client: MindbodyUser }>('/client/updateclient', formData).send();
      navigate('/account');
    } catch (error) {
      console.error('Update error:', error instanceof Error ? error.message : error);
    }
  };

  return (
    <Box as={FormProvider} {...formMethods} w="full">
      <HStack width="100%" justifyContent="space-between" margin="1em 0 2em">
        <Heading className="accountMainTitle" size="md" textTransform="uppercase">
          Modifier mes informations
        </Heading>
        <Button variant="contained" onClick={() => navigate(-1)}>
          Retour
        </Button>
      </HStack>

      <VStack as="form" onSubmit={handleSubmit(onSubmit)} spacing={4} align="stretch" padding="1em 0">
        <FormControl isRequired>
          <FloatingLabelInput label={t('Nom')} {...register('LastName')} />
        </FormControl>

        <FormControl isRequired>
          <FloatingLabelInput label={t('Prénom')} {...register('FirstName')} />
        </FormControl>

        <FormControl>
          <FloatingLabelInput label={t('Adresse')} {...register('AddressLine1')} />
        </FormControl>

        <HStack>
          <FormControl isRequired>
            <FloatingLabelInput label={t('Code Postal')} {...register('PostalCode')} />
          </FormControl>
          <FormControl isRequired>
            <FloatingLabelInput label={t('Ville')} {...register('City')} />
          </FormControl>
        </HStack>

        <FormControl isRequired>
          <FloatingLabelInput label={t('Téléphone')} {...register('MobilePhone')} />
        </FormControl>

        <FormControl isRequired>
          <FloatingLabelInput disabled={true} label={t('Email')} {...register('Email')} />
        </FormControl>

        <FormControl textAlign={'left'}>
          <Checkbox checked={true} borderColor="black" {...register('SendPromotionalEmails')} textAlign={'left'}>
            Rester informé du planning, des événements et des offres
          </Checkbox>
        </FormControl>

        <VStack padding="2em 1em 0">
          <Button variant="contained" type="submit" alignContent={'center'} mt={4} isLoading={isSubmitting}>
            METTRE À JOUR
          </Button>
        </VStack>
      </VStack>
    </Box>
  );
}
